import React from 'react';
import ChartView from '../../../_common/components/ChartView';
import {chartColorsArray} from '../../../_common/styles/chartColors';

export const ChartPie = ({
                           data,
                           labels,
                           header,
                           containerClassNames,
                           ...rest
                         }) => {

  const options = {
    chart: {
      type: 'pie',
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
      dropShadow: {
        enabled: true,
        blur: 10,
        left: 0,
        top: 5,
        opacity: 0.2
      }
    },
    labels,
    colors: chartColorsArray,
    stroke: {
      show: true,
      width: 2,
      colors: ['rgba(255, 255, 255, 0.4)']
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'radial',
        shadeIntensity: 0.5,
        gradientToColors: chartColorsArray.map(color => color),
        inverseColors: true,
        opacityFrom: 0.85,
        opacityTo: 1,
        stops: [0, 90, 100]
      }
    },
    plotOptions: {
      pie: {
        customScale: 0.99,
        offsetX: 0,
        offsetY: 0,
        expandOnClick: true,
        dataLabels: {
          offset: -5
        }
      }
    },
    legend: {
      show: true,
      direction: 'rtl',
      position: 'bottom',
      overflowY: 'auto',
      height: 50,
      fontFamily: 'Inter, system-ui, -apple-system', // Apple-style typography
      fontWeight: 500,
      itemMargin: {
        horizontal: 4,
        vertical: 4
      },
      markers: {
        radius: 12,
        offsetX: '-1px'
      }
    },
    grid: {
      padding: {
        left: 0,
        right: 0,
        bottom: 10
      }
    },
    states: {
      hover: {
        filter: {
          type: 'lighten',
          value: 0.15
        }
      }
    },
    tooltip: {
      enabled: true,
      custom: ({series, seriesIndex, w}) => {
        const label = w.globals.labels[seriesIndex];
        const value = series[seriesIndex];
        const bg = chartColorsArray[seriesIndex];
        return `
        <div style="
          direction: rtl;
          text-align: right;
          padding: 8px;       
          font-weight: 500;
          background: ${bg};
          color: #fff;        
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <span style="font-weight:600; margin-left: 0.5rem">${label}: </span>
          <span>${value}</span>
        </div>
      `;
      }
    }
  };

  return (
    <ChartView
      options={options}
      series={data}
      type={'pie'}
      width={'100%'}
      height={'400px'}
      containerClassNames={containerClassNames}
      header={header}
      {...rest}
    />
  )
}